// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

export const initializeFirebaseMessaging = (webParams) => {
    const firebaseConfig = {
        apiKey: webParams.firebase_apikey,
        authDomain: webParams.firebase_auth_domain,
        projectId: webParams.firebase_project_id,
        messagingSenderId: webParams.firebase_messaging_sender_id,
        appId: webParams.firebase_app_id,
    };

    console.log('Firebase config:', firebaseConfig);

    const app = initializeApp(firebaseConfig);
    return getMessaging(app);
};

export {getToken, onMessage };